<template>
  <v-row>
    <v-col cols="12">
      <vuetify-table
        :headers="headers"
        :apiURL="apiURL"
        :readonly="true"
        :title="title"
        :bus="bus"
      >
        <template v-slot:footer>
          <v-row v-if="!showAdd" class="mx-2" justify="space-around">
            <v-col>
              <v-btn
                v-if="can('agregar_servicio_empresa')"
                :loading="loadServices"
                :color="themeColor"
                class="white--text"
                @click="showServices()"
              >Agregar Servicio</v-btn>
            </v-col>
          </v-row>
          <v-row class="mx-2" justify="center" v-else>
            <v-col>
              <v-select
                v-model="service"
                :items="servicesList"
                item-value="id"
                label="Tipo de Servicio"
                required
              >
                <template v-slot:selection="data">
                  <v-chip
                  :color="getColor(data.item.available)"
                  dark
                >
                  <span v-if="data.item.available >= 1">
                    {{ data.item.servicio }} - {{ data.item.nombre }}
                    ({{ data.item.cantidad }} folios - {{ data.item.tiempo }} meses)
                    Disponibles {{ data.item.available }}
                  </span>
                  <span v-else>
                    {{ data.item.servicio }} - {{ data.item.nombre }}
                    ({{ data.item.cantidad }} folios - {{ data.item.tiempo }} meses)
                    Disponibles {{ data.item.available }}
                  </span>
                </v-chip>
                </template>
                <template v-slot:item="data">
                    {{ data.item.servicio }} - {{ data.item.nombre }}
                    ({{ data.item.cantidad }} folios - {{ data.item.tiempo }} meses)
                    Disponibles {{ data.item.available }}
                </template>
              </v-select>
            </v-col>
            <v-col>
              <v-btn :color="themeColor" class="white--text" @click="assignService()">Asignar</v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                :color="themeColor"
                @click="showCycles(item)"
                v-on="on"
              >mdi-credit-card-multiple</v-icon>
            </template>
            <span>Ciclos</span>
          </v-tooltip>
          <v-tooltip bottom v-if="can('eliminar_licencia')">
            <template v-slot:activator="{ on }">
              <v-icon
                :color="themeColor"
                @click="openModalDelete(item)"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
        <template v-slot:item.nombre>
          <span>APP</span>
        </template>
      </vuetify-table>
    </v-col>
    <v-dialog
      v-model="dialog"
      max-width="620"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Estás seguro de que quieres eliminar este registro?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatusDelete"
            @click.prevent="deleteItem()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('enterprises') };
  },
  props: {
    id: { default: '' },
    dealerId: { default: '' },
  },
  data: () => ({
    name: '',
    service: '',
    servicesList: [],
    serviceAmount: 1,
    showAdd: false,
    loadServices: false,
    folios: 0,
    bus: new Vue(),
    dialog: false,
    toggleStatusDelete: false,
    headers: [
      {
        text: 'Tipo',
        value: 'servicio',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Servicio',
        value: 'nombre',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Licencia',
        value: 'codigo',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Tiempo (Meses)',
        value: 'tiempo',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Cadencia (Meses)',
        value: 'cadencia',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Folios',
        value: 'folios',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Folios (Utilizados)',
        value: 'folios_utilizados',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha de Asignación',
        value: 'created_at',
        sortable: true,
      },
      {
        text: 'Fecha Inicio',
        value: 'fecha_inicio',
        sortable: true,
      },
      {
        text: 'Fecha Fin',
        value: 'fecha_fin',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'active',
        sortable: true,
      },
      {
        text: 'Acciones',
        value: 'action',
      },
    ],
  }),
  computed: {
    apiURL() {
      return `/api/enterprises/${this.id}/licence`;
    },
    title() {
      return 'Licencias';
    },
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
  },
  components: {
    VuetifyTable,
  },
  mounted() {
    if (!this.can('cambiar_estado_licencia_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
    window.axios.get(`/api/enterprises/${this.id}`)
    .then((result) => {
      this.name = `${result.data.name} - ${result.data.ruc}`;
    });
  },
  methods: {
    showServices() {
      if (this.servicesList.length === 0) {
        const url = `/api/catalogs/dealers/${this.user.dealer_id}/enterprises/${this.id}/licences`;
        window.axios.get(url).then((result) => {
          this.showAdd = !this.showAdd;
          this.servicesList = result.data.items;
        });
      } else {
        this.showAdd = !this.showAdd;
      }
    },
    assignService() {
      const folios = this.servicesList.filter(
        (service) => service.id === this.service,
      )[0].cantidad;
      const data = {
        service: this.service,
        enterprise_id: this.id,
        dealer: this.user.dealer_id,
        folios,
        type: 'E',
      };
      if (this.dealer_id) {
        data.dealer = this.dealer_id;
      }
      window.axios.post('/api/licences/associate', data)
      .then(() => {
        this.bus.$emit('refreshTable');
        this.showAdd = !this.showAdd;
        this.servicesList = [];
        this.showServices();
      });
    },
    showCycles(item) {
      this.$router.push({
        path: `${this.$router.currentRoute.path}/${item.licence_id}/ciclos`,
        params: { id: item.id },
      });
    },
    getColor(available) {
      if (available >= 1) return 'green';
      return 'red';
    },
    openModalDelete(item) {
       this.dialog = true;
       this.item = item;
    },
    deleteItem() {
      this.toggleStatusDelete = true;
      const url = `${this.apiURL}/${this.item.id}`;
      window.axios.delete(url)
      .then((response) => {
        this.$store.dispatch('notifications/show', {
          message: response.data.message,
          type: response.data.type,
        });
        this.toggleStatusDelete = false;
        this.bus.$emit('refreshTable');
        this.showAdd = !this.showAdd;
        this.servicesList = [];
        this.showServices();
        this.dialog = false;
      });
    },
  },
};
</script>
